export const MAIL_TEMPLATE = {
  FINISH: "SETF",
  REJECT: "SETR",
  APPROVE: "SETA",
};

export const MAIL_TEMPLATE_LIST_TRAINEE = {
  FINISH: "LTEF",
  REJECT: "LTER",
  approve: "LTEA",
};
